import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import { getAllSkills } from '../../../redux/skills/SkillsActions';
import { getLoggedInUser } from '../../../redux/user/UserActions';

// Services

// Partials
import Sidebar from '../../../partials/aside/Sidebar';
import Footer from '../../../partials/footer/Footer';
import Header from '../../../partials/header/Header';
// Pages
import Settings from '../Settings/Settings';
import AdminAccount from '../account/AdminAccount';
import AdminChangePassword from '../account/AdminChangePassword';
import ContactUsList from '../contact-us/ContactUsList';
import Dashboard from '../dashboard/Dashboard';
import NanniesList from '../nannies/NanniesList';
import NannyCreate from '../nannies/NannyCreate';
import NannyUpdate from '../nannies/NannyUpdate';
// import FamiliesList from '../families/FamiliesList';
import FamilyCreate from '../families/FamilyCreate';
import FamilyUpdate from '../families/FamilyUpdate';
import FamilyView from '../families/FamilyView';
import FamilyNannyRequests from '../family-nanny-requests/FamilyNannyRequests';
import ApplicationDetails from '../job-postings/ApplicationDetails';
import JobPostingCreate from '../job-postings/JobPostingCreate';
import JobPostingList from '../job-postings/JobPostingList';
import JobPostingUpdate from '../job-postings/JobPostingUpdate';
import NannyView from '../nannies/NannyView';
import NannyRequests from '../requests/NannyRequests';
import SitterRequests from '../requests/SitterRequests';
import SkillCreate from '../skills/SkillCreate';
import SkillList from '../skills/SkillList';
import SkillUpdate from '../skills/SkillUpdate';
import SubscribersList from '../subscriptions/SubscribersList';

const Layout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLoggedInUser());
    dispatch(getAllSkills());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Header />
      <div className="d-flex align-items-stretch">
        <Sidebar />
        <div className="page-holder w-100 d-flex flex-wrap">
          <Routes>
            <Route path={'*'} element={<Navigate replace to={'/admin/dashboard'} />} />
            <Route path={'/dashboard'} element={<Dashboard />} />
            <Route path={'/nanny'} element={<Navigate replace to={'/admin/nanny/list'} />} />
            <Route path={'/nanny/list'} element={<NanniesList />} />
            <Route path={'/nanny/create'} element={<NannyCreate />} />
            <Route path={'/nanny/update/:id'} element={<NannyUpdate />} />
            <Route path={'/nanny/view/:id'} element={<NannyView />} />

            <Route path={'/family'} element={<Navigate replace to={'/admin/family/list'} />} />
            <Route path={'/family/list'} element={<FamilyNannyRequests />} />
            <Route path={'/family/create'} element={<FamilyCreate />} />
            <Route path={'/family/update/:id'} element={<FamilyUpdate />} />
            <Route path={'/family/view/:id'} element={<FamilyView />} />

            <Route path={'/skills'} element={<Navigate replace to={'/admin/skills/list'} />} />
            <Route path={'/skills/list'} element={<SkillList />} />
            <Route path={'/skills/create'} element={<SkillCreate />} />
            <Route path={'/skills/update/:id'} element={<SkillUpdate />} />

            <Route path={'/account/update'} element={<AdminAccount />} />
            <Route path={'/account/change-password'} element={<AdminChangePassword />} />

            <Route path={'/postings'} element={<Navigate replace to={'/admin/postings/list'} />} />
            <Route path={'/postings/list'} element={<JobPostingList />} />
            <Route path={'/postings/create'} element={<JobPostingCreate />} />
            <Route path={'/postings/update/:id'} element={<JobPostingUpdate />} />
            <Route path={'/postings/applications/list/:id'} element={<ApplicationDetails />} />

            <Route path={'/requests/nanny'} element={<NannyRequests />} />
            <Route path={'/requests/sitter'} element={<SitterRequests />} />

            <Route path={'/contact-us/list'} element={<ContactUsList />} />
            <Route path={'/subscribers/list'} element={<SubscribersList />} />
            <Route path={'/family-nanny-requests'} element={<FamilyNannyRequests />} />
            <Route path={'/settings'} element={<Settings />} />
          </Routes>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Layout;
